var _path, _path2, _path3, _path4, _rect, _rect2, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6638 5.34933C11.3198 5.34933 10.8642 5.34171 10.2968 5.34171C8.9133 5.34171 7.77562 4.19657 7.77562 2.8V0.349714C7.77562 0.156952 7.62179 0 7.43086 0H3.40086C1.52013 0 0 1.54362 0 3.43543V11.645C0 13.6297 1.59255 15.2381 3.55778 15.2381H9.55909C11.433 15.2381 12.9524 13.7044 12.9524 11.811V5.69219C12.9524 5.49867 12.7992 5.34248 12.6076 5.34324C12.2855 5.34552 11.8992 5.34933 11.6638 5.34933Z",
    fill: "#6EC2D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58793 0.432288C9.36012 0.195335 8.9624 0.358383 8.9624 0.686764V2.69591C8.9624 3.53857 9.6565 4.23191 10.4992 4.23191C11.0302 4.238 11.7677 4.23953 12.394 4.238C12.7148 4.23724 12.8778 3.854 12.6554 3.62238C11.8515 2.78657 10.4123 1.28867 9.58793 0.432288Z",
    fill: "#6EC2D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17062 7.54192H8.31844C8.63159 7.54192 8.88606 7.79563 8.88606 8.10877C8.88606 8.42192 8.63159 8.67639 8.31844 8.67639H4.17062C3.85747 8.67639 3.60376 8.42192 3.60376 8.10877C3.60376 7.79563 3.85747 7.54192 4.17062 7.54192Z",
    fill: "#C2EBF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27349 10.585H4.17062C3.85747 10.585 3.60376 10.8387 3.60376 11.1518C3.60376 11.465 3.85747 11.7195 4.17062 11.7195H8.27349C8.58663 11.7195 8.84111 11.465 8.84111 11.1518C8.84111 10.8387 8.58663 10.585 8.27349 10.585Z",
    fill: "#C2EBF4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.97607,
    y: 6.35718,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    fill: "#6EC2D4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.97607,
    y: 6.35718,
    width: 10.1429,
    height: 10.1429,
    rx: 5.07143,
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3713 11.2008C13.434 11.2603 13.4717 11.3419 13.4717 11.4297C13.4717 11.5175 13.434 11.599 13.3713 11.6586L11.3987 13.4964C11.2733 13.6155 11.0726 13.6061 10.9566 13.4806C10.9001 13.4211 10.8719 13.3426 10.8719 13.2673C10.8719 13.1827 10.9065 13.095 10.9722 13.0322L12.3616 11.7339H8.93691C8.76446 11.7339 8.62326 11.5928 8.62326 11.4203C8.62326 11.2478 8.76446 11.1067 8.93691 11.1067H12.3616L10.9722 9.81777C10.8468 9.69858 10.8374 9.50412 10.9566 9.3756C11.0757 9.25016 11.2733 9.24391 11.3987 9.35993L13.3713 11.2008Z",
    fill: "#DDF7FD",
    stroke: "#DDF7FD",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignLead);
export default __webpack_public_path__ + "static/media/assignLead.2a6bf31af982758e8400b72297147ec8.svg";
export { ForwardRef as ReactComponent };